<!-- @format -->

<shared-components-breadcrumbs></shared-components-breadcrumbs>
<div class="hmf-grid hmf-mb-l hmf-pb-s border-bottom">
	@if (!showBtsDashUpdates) {
		<div class="hmf-col hmf-span-12 hmf-span-m-9 hmf-p-0">
			<p class="hmf-header-bold-l hmf-mb-l">Your Lists</p>
			<div class="hmf-display-none hmf-display-m-block">
				<!-- Desktop -->
				<div class="hmf-grid">
					<div class="hmf-col hmf-span-4 hmf-pl-0 hmf-mb-m">
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Get Organized</p>
						<p class="hmf-body-s hmf-mb-0">
							Create lists to help you remember exactly what you need, and where to
							find it
						</p>
					</div>
					<div class="hmf-col hmf-span-4">
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Add Gear You Love</p>
						<p class="hmf-body-s hmf-mb-0">
							Simply click the heart as you shop to keep track of what gear catches
							your eye
						</p>
					</div>
					<div class="hmf-col hmf-span-4">
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Share</p>
						<p class="hmf-body-s hmf-mb-0">
							Send your curated lists and favorite items to your friends, family, and
							teammates
						</p>
					</div>
				</div>
			</div>
			<div class="hmf-display-block hmf-display-m-none">
				<!-- Mobile -->
				<div class="hmf-grid">
					<div class="hmf-col hmf-span-4 hmf-pl-0">
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Organize</p>
						<p class="hmf-body-s hmf-mb-0">Create multiple lists for your needs</p>
					</div>
					<div class="hmf-col hmf-span-4">
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Add</p>
						<p class="hmf-body-s hmf-mb-0">
							Simply tap the heart to save gear you love
						</p>
					</div>
					<div class="hmf-col hmf-span-4">
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Share</p>
						<p class="hmf-body-s hmf-mb-0">
							Send to your friends, family, or teammates
						</p>
					</div>
				</div>
			</div>
		</div>
	} @else {
		<div class="hmf-col hmf-span-12 hmf-span-m-9 hmf-p-0">
			<p class="hmf-header-bold-l hmf-mb-l">Lists</p>
			<div class="hmf-display-none hmf-display-m-block">
				<!-- Desktop -->
				<div class="hmf-grid align-items-start">
					<div class="hmf-col hmf-span-4 hmf-pl-0 hmf-mb-m hmf-display-flex">
						<div class="hmf-mr-xxs hmf-mt-0 hmf-pt-0">
							<homefield-icon
								height="16px"
								width="16px"
								name="reaction-love-filled"
								class="lists-dashboard-icon">
							</homefield-icon>
						</div>
						<div>
							<p class="hmf-header-bold-xs hmf-mb-xxxs">Add Gear You Love</p>
							<p class="hmf-body-s hmf-mb-0">
								Keep track of what you need and where to find it-create lists and
								use the heart icon to favorite your finds
							</p>
						</div>
					</div>
					<div class="hmf-col hmf-span-4 hmf-display-flex">
						<div class="hmf-mr-xxs hmf-mt-0 hmf-pt-0">
							<homefield-icon
								height="16px"
								width="16px"
								name="mobile-barcode-off"
								class="lists-dashboard-icon">
							</homefield-icon>
						</div>
						<div>
							<p class="hmf-header-bold-xs hmf-mb-xxxs">Activate Store Mode</p>
							<p class="hmf-body-s hmf-mb-0">
								Use the app to open your list, scan barcodes, and add items in store
							</p>
						</div>
					</div>
					<div class="hmf-col hmf-span-4 hmf-display-flex">
						<div class="hmf-mr-xxs hmf-mt-0 hmf-pt-0">
							<homefield-icon
								height="16px"
								width="16px"
								name="user-group"
								class="lists-dashboard-icon">
							</homefield-icon>
						</div>
						<div>
							<p class="hmf-header-bold-xs hmf-mb-xxxs">Share</p>
							<p class="hmf-body-s hmf-mb-0">
								Share your curated lists and favorite items with friends, family, or
								teammates easily
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="hmf-display-block hmf-display-m-none">
				<!-- Mobile -->
				<div class="hmf-grid">
					<div class="hmf-col hmf-span-4 hmf-pl-0">
						<homefield-icon
							height="16px"
							width="16px"
							name="reaction-love-filled"
							class="lists-dashboard-icon">
						</homefield-icon>
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Create Lists</p>
						<p class="hmf-body-s hmf-mb-0">Organize & favorite your finds</p>
					</div>
					<div class="hmf-col hmf-span-4">
						<homefield-icon
							height="16px"
							width="16px"
							name="mobile-barcode-off"
							class="lists-dashboard-icon">
						</homefield-icon>
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Store Mode</p>
						<p class="hmf-body-s hmf-mb-0">Add in store with our app</p>
					</div>
					<div class="hmf-col hmf-span-4">
						<homefield-icon
							height="16px"
							width="16px"
							name="user-group"
							class="lists-dashboard-icon">
						</homefield-icon>
						<p class="hmf-header-bold-xs hmf-mb-xxxs">Share</p>
						<p class="hmf-body-s hmf-mb-0">Send your lists easily</p>
					</div>
				</div>
			</div>
		</div>
	}
	<div class="hmf-col hmf-span-12 hmf-span-m-3 hmf-p-0 hmf-mt-m hmf-mt-m-0 hmf-display-flex">
		<hmf-button
			id="create-new-list"
			tabindex="0"
			[ngClass]="{ 'hmf-ml-l': !isMobile }"
			[variant]="'primary'"
			[text]="'Create New List'"
			[size]="'medium'"
			[loading]="false"
			[disabled]="false"
			[label]="'Create New List'"
			[icon]="'sign-circled-add-filled'"
			(click)="openSidePanel()">
		</hmf-button>
	</div>
</div>
<div class="hmf-mb-l">
	<hmf-alert-banner
		*ngIf="showDeletedBanner"
		[messageType]="'success'"
		[messageTitle]="'List Deleted'"
		class="hmf-mb-l">
	</hmf-alert-banner>
	<hmf-alert-banner
		*ngIf="listCountErr"
		[messageType]="'error'"
		[messageTitle]="'Max List Limit Reached'"
		[messageBody]="
			'Looks like you\'ve created the max amount of lists available. Clear out some lists to make room for new ones!'
		">
	</hmf-alert-banner>
</div>

<div class="hmf-grid">
	<ng-container *ngIf="displayedLists.length; else loading">
		<ng-container *ngFor="let list of displayedLists; last as isLast">
			<my-account-list-components-list-card
				*ngIf="
					dataDrivenListEnabled && hasRecommendedList
						? !isLast || displayedLists.length > totalListCount
						: true
				"
				class="hmf-col hmf-span-l-4 hmf-span-m-6 hmf-span-s-12 hmf-text-align-left"
				[list]="list"
				[recommendedAnalyticsData]="
					list.analytics?.recommendationData
				"></my-account-list-components-list-card>
		</ng-container>
	</ng-container>
	<ng-template #loading>
		<div class="skeleton-card hmf-subtle-shadow hmf-display-flex hmf-mb-l">
			<my-account-components-auth-skeleton-list-card></my-account-components-auth-skeleton-list-card>
		</div>
	</ng-template>
</div>
<div
	class="hmf-display-flex hmf-justify-content-center hmf-w-100"
	*ngIf="determineViewMoreVisibility()">
	<hmf-button
		class="view-more-button-width"
		[ngClass]="{ disablePointerEvents: loadingMoreLists }"
		[variant]="'secondary'"
		[text]="'View More'"
		[size]="'medium'"
		[label]="'View More'"
		(click)="viewMoreClicked()">
	</hmf-button>
</div>

<homefield-side-panel
	[showSidePanel]="showSidePanel"
	[width]="40"
	[duration]="400"
	(sidePanelIsOpen)="onPanelEvent($event)">
	<div
		ngProjectAs="customPanelTitle"
		class="hmf-header-bold-xs">
		Create a New List
	</div>
	<div ngProjectAs="customPanelBody">
		<div
			ngProjectAs="customPanelBody"
			class="hmf-display-flex hmf-flex-column hmf-px-m hmf-mt-s">
			<div class="hmf-position-relative">
				<form
					[formGroup]="listForm"
					#listsForm="ngForm"
					(ngSubmit)="saveList()"
					class="hmf-display-absolute hmf-span-12">
					<div class="hmf-mb-s">
						<hmf-text-input
							id="new-list-input"
							required
							type="text"
							placeholder="What is your list name?"
							formControlName="name"
							[maxLength]="50"
							(input)="onInputUpdate($event)"
							[errorIconEnabled]="
								listForm.get('name').invalid && listForm.get('name').touched
							"
							[error]="listForm.get('name').invalid && listForm.get('name').touched"
							[helperText]="
								(listForm.controls['name'].hasError('required') &&
								listForm.controls['name'].touched
									? 'Please Enter a List Name'
									: '') ||
								(listForm.get('name')?.hasError('listError') &&
								!listForm.controls['name'].valid
									? listError
									: '')
							">
						</hmf-text-input>
					</div>

					<div
						class="hmf-flex-row hmf-flex-nowrap hmf-justify-content-between mf-soft-radius">
						<div class="hmf-flex-column">
							<p class="hmf-subheader-m">Make List Public</p>
							<p class="hmf-body-m subtle-text">
								When set to public your list can be shared and viewed by others.
							</p>
						</div>
						<mat-slide-toggle
							name="formListVisbility"
							ngDefaultControl
							(change)="onInputUpdate($event)"
							[checked]="listVisibility"
							hideIcon="true"></mat-slide-toggle>
					</div>

					<button
						[ngClass]="{ 'hmf-mt-l-s hmf-mt-m-l': listError }"
						hmf-button
						homefield-button
						class="hmf-span-12 hmf-soft-radius hmf-py-xxs"
						tabindex="0"
						[variant]="'primary'"
						[text]="'CREATE'"
						[size]="'medium'"
						[label]="'Create'"
						[disabled]="listForm.invalid || listCreationError"
						type="submit">
						CREATE
					</button>
				</form>
			</div>
		</div>
	</div>
</homefield-side-panel>

<hmf-modal
	#listWelcomeModal
	[className]="'list-welcome-modal'"
	[transparentBackground]="false"
	[closable]="true"
	[closableVariant]="'primary'"
	[interactability]="false"
	[clickableBackground]="true"
	[focus]="true"
	(opened)="listWelcomeModalDidOpen()"
	(closed)="listWelcomeModalDidClose()">
	<div id="list-modal-scroll-anchor"></div>
	<div class="hmf-mx-auto hmf-mt-xxl hmf-l-mt-xxxl">
		<homefield-icon
			class="reaction-love-filled"
			[width]="isMobile ? '32px' : '48px'"
			height="isMobile ? '32px' : '48px'"
			fill="var(--hmf-label-primary-static)"
			name="reaction-love-filled"></homefield-icon>
	</div>
	<div class="hmf-mx-auto list-modal-header hmf-mt-m">Welcome to Lists</div>
	<div
		class="hmf-grid hmf-mt-l hmf-mb-xxl hmf-mb-m-xxxl hmf-ml-xs hmf-ml-m-xxl hmf-mr-xs hmf-mr-m-xxl">
		<div class="hmf-col hmf-span-12 hmf-span-m-4">
			<div class="hmf-header-bold-xs hmf-text-align-center">Get Organized</div>
			<div class="hmf-header-regular-s hmf-text-align-center hmf-mt-xxs">
				Create lists to help you remember exactly what you need, and where to find it
			</div>
		</div>
		<div class="hmf-col hmf-span-12 hmf-span-m-4 hmf-mt-s hmf-mt-m-0">
			<div class="hmf-header-bold-xs hmf-text-align-center">Add Gear You Love</div>
			<div class="hmf-header-regular-s hmf-text-align-center hmf-mt-xxs">
				Simply click the heart as you shop to keep track of what gear catches your eye
			</div>
		</div>
		<div class="hmf-col hmf-span-12 hmf-span-m-4 hmf-mt-s hmf-mt-m-0">
			<div class="hmf-header-bold-xs hmf-text-align-center">Share</div>
			<div
				id="list-modal-scroll-anchor"
				class="hmf-header-regular-s hmf-text-align-center hmf-mt-xxs">
				Send your curated lists and favorite items to your friends, family, and teammates
			</div>
		</div>
	</div>
</hmf-modal>
